import { render, staticRenderFns } from "./HomeSectionDocs.vue?vue&type=template&id=0949e428&scoped=true"
import script from "./HomeSectionDocs.vue?vue&type=script&lang=js"
export * from "./HomeSectionDocs.vue?vue&type=script&lang=js"
import style0 from "./HomeSectionDocs.vue?vue&type=style&index=0&id=0949e428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0949e428",
  null
  
)

export default component.exports